module.exports = __webpack_public_path__ + "img/img-header-1.92014597.png";